import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Input, Modal, Select, Button, Card } from 'antd';
import axios from 'axios';

import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

import './RegisterForm.css';
import { formatPhoneNumber } from '../../utils/utils';
import messages from './Messages';

const formItemLayout = {
  inputs: {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    },
  },
  buttons: {
    wrapperCol: { span: 24 },
  },
};

export default function RegisterForm({ carrierConfig }) {
  const { t: translate } = useTranslation('carrierSignup');

  const [form] = Form.useForm();
  const [phoneNumber, setPhoneNumber] = useState();
  const [isDisable, setIsDisable] = useState(false);

  const errorModal = (text) => {
    setIsDisable(false);
    Modal.error({
      title: translate('register.errormodal.title'),
      content: text,
    });
  };

  const successModal = () => {
    setIsDisable(false);
    Modal.success({
      title: translate('register.successModal.title'),
      content: translate('register.successModal.content'),
      onOk() {
        window.location.href = process.env.REACT_APP_APP_URL;
      },
    });
  };

  const submit = () => {
    form.setFieldsValue({ phone: formatPhoneNumber(phoneNumber) });
    form
      .validateFields()
      .then((values) => {
        setIsDisable(true);

        const { companyName, email, name, phone, surname, warehouseKeys } = values;

        const warehouseIds = warehouseKeys;

        const postData = {
          firstName: name,
          lastName: surname,
          email,
          phone,
          companyName,
          warehouseIds,
        };

        axios
          .post(process.env.REACT_APP_API_ENDPOINT, postData)
          .then((res) => {
            successModal();
          })
          .catch((error) => {
            errorModal(translate(error?.response?.data?.body?.message || error?.response?.data?.body?.errCode || 'Error precessing request'));
          });
      })
      .catch((error) => console.log(error));
  };

  return (
    <div className='formContainer'>
      <Card className='cardWShadow' bordered={false} bodyStyle={{ padding: '0px 50px' }}>
        <Form name='register' form={form} {...formItemLayout.inputs} className='register-form'>
          <h2>{translate('register.form.head')}</h2>

          <Form.Item
            label={translate('register.form.labels.fistname')}
            name='name'
            rules={[{ required: true, message: translate('register.form.messages.fistname') }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label={translate('register.form.labels.lastname')}
            name='surname'
            rules={[{ required: true, message: translate('register.form.messages.lastname') }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label={translate('register.form.labels.email')}
            name='email'
            rules={[{ required: true, message: translate('register.form.messages.email') }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label={translate('register.form.labels.phonenumber')}
            name='phone'
            rules={[{ required: true, message: translate('register.form.messages.phonenumber') }]}
          >
            <PhoneInput country={carrierConfig?.phoneCountryCode || 'de'} value={phoneNumber} onChange={setPhoneNumber} />
          </Form.Item>

          <Form.Item
            name='companyName'
            label={translate('register.form.labels.companyname')}
            rules={[{ required: true, message: translate('register.form.messages.companyname') }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name='warehouseKeys'
            label={translate('register.form.labels.warehouse')}
            rules={[{ required: true, message: translate('register.form.messages.warehouse') }]}
          >
            <Select mode='multiple' className='select' placeholder={translate('register.form.labels.whselect')} onChange={() => {}} allowClear>
              {carrierConfig?.carrier?.warehouses &&
                carrierConfig?.carrier.warehouses.map((warehouse) => (
                  <Select.Option key={`whId_${warehouse.id}`} value={warehouse.id}>
                    {warehouse.value}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>

          <Form.Item {...formItemLayout.buttons} className='alignRight'>
            <Button type='primary' onClick={submit} disabled={isDisable}>
              {translate('register.form.labels.register')}
            </Button>
            <Button
              style={{ margin: '0 0 0 8px' }}
              onClick={() => {
                form.resetFields();
              }}
            >
              Clear
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}
